class Merger {

    merge(objectA, objectB) {
        return Object.assign({}, objectA, objectB);
    }

}

const merger = new Merger();
export default merger;